import React, {useEffect, useRef, useState} from "react";
import {Card, FlexItem, FlexLayout, Link, Spinner, StackLayout, Text} from "@salt-ds/core";
import CardAlert from "../../components/common/card-alert/CardAlert";
import CardHeader from "../../components/common/card-header/CardHeader";
import Constants from "../../components/common/Constants";
import ChangePasswordComponent from "../../components/common/ChangePasswordComponent";
import PageNavigationCustom from "../../components/common/page-navigation/PageNavigationCustom";
import {useLocation, useNavigate} from 'react-router';
import {useIntl} from 'react-intl';

function ForcedChangePasswordPage()  {
    const formRef = useRef();
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [passwordChangeSuccess, setPasswordChangeSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const forgotPasswordLink = <Link href="/auth/public/app/forgotPassword"
                                        className="links">{Constants.homePageLoginCardForgotPasswordLabel}</Link>;
    const navigate = useNavigate();
    const location = useLocation();
    const intl = useIntl();
    const mainRef = useRef(null);

    useEffect(() => {
        document.title = intl.formatMessage({id: 'logon.ui.ChangePassword.page.title'});
        // Set focus to main element for screen reader announcement
        if (mainRef.current) {
            mainRef.current.focus();
        }

        const expectedPreviousPage = '/login';
        if (location.state?.from !== expectedPreviousPage) {
            navigate('/');
        }
    }, [intl, location, navigate]);

    const showErrorOnPage = (error) => {
        setMessage(error.message);
        setHasError(true);
        setIsLoading(false);
    }
    const [showAlertBox,setShowAlertBox] = useState(false);
    const showSuccessOnPage = (message)=> {
        setHasError(false);
        setShowAlertBox(true);
        setMessage(message);
        setIsLoading(false);
    }

    const handleNextButtonClick = () => {
        setIsLoading(true);
        if(showAlertBox || passwordChangeSuccess) {
            window.location.href = `${window.location.origin}/card/home`
            return;
        }
        if(formRef.current && (!showAlertBox && !hasError)) {
            formRef.current.submitForm();
        }
    }

    return (
        <main ref={mainRef} role="main" aria-label="Force Change Password Page" tabIndex="-1">
            <FlexLayout className={"page-content"}>
                {isLoading ? (
                    <FlexItem className="spinner-wrapper">
                        <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
                    </FlexItem>
                ) : (
                    <FlexItem  className={`error-wrapper ${hasError || showAlertBox ? 'visible' : ''}`}>
                        <div>
                            <CardAlert setShowAlertBox={setShowAlertBox} status={ hasError ? "error":"success"} setHasError={setHasError}>
                                {message}
                            </CardAlert>
                        </div>
                    </FlexItem>
                )}
                <FlexItem>
                    <Card className={"card-wrapper"}>
                        <FlexItem className="card-content">
                            <StackLayout gap={3}>

                                <CardHeader style={{maxWidth: '16.5rem'}} heading={Constants.forceChangePassword}/>
                                <FlexItem>
                                    <Text>
                                        {Constants.forceChangePasswordInstructionalText(forgotPasswordLink)}
                                    </Text>
                                </FlexItem>
                                <ChangePasswordComponent  showSuccessOnPage={showSuccessOnPage} showErrorOnPage={showErrorOnPage} setPasswordChangeSuccess={setPasswordChangeSuccess} ref={formRef}
                                                          isForceChangePasswordFlow={true} isDisabled={passwordChangeSuccess}
                                setIsLoading={setIsLoading} isLoading={isLoading}/>
                                <PageNavigationCustom isCancelNotAllowed={true} nextButtonText={passwordChangeSuccess ?"CONTINUE":"NEXT"} previousPage={"indexPage"} onSubmit={handleNextButtonClick} isLoading={isLoading}/>
                            </StackLayout>
                        </FlexItem>
                    </Card>
                </FlexItem>
            </FlexLayout>
        </main>
    );
}

export default ForcedChangePasswordPage;